(function () {
    'use strict';

    angular
        .module('core.components')
        .controller('ForgotPasswordController', ForgotPasswordController)

    /** @ngInject */
    function ForgotPasswordController(PersonService, HelperService) {
        const vm = this;

        vm.recoverPassword = () => {
            HelperService.startLoading('.loading-holder');

            PersonService
                .requestPasswordChange(vm.forgotData.Login)
                .then(success => {
                    vm.recoverEmail = success;
                    vm.step = 2;
                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                })
        }

        init();

        function init() {
            vm.recoverEmail = null;
            vm.step = 1;
        }
    }
}());